module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_hardangled_shadow.94194b87.png";